module.exports = __webpack_public_path__ + "media/assets/images/tour/2_Tour_5-7d75375c0b43d86298de49007cce5027.png";